import {FC} from "react";
import Tooltip from "components/Tooltip";
import Ordering from "./Ordering";
import ManualFilters from "./ManualFilters";
import {Search, Lock} from "lucide-react";

const TalentFinderLocker: FC = () => {
  const onContactSales = () => {
    const email = "anthonybirch@akadian.com";
    const subject = "Interested in Talent Finder";
    const body = "Hi Anthony, I'm interested in Talent Finder. Can you please provide more information?";
    window.open(`mailto:${email}?subject=${subject}&body=${body}`);
  };

  return (
    <div className="w-full h-full flex flex-col overflow-hidden" style={{backgroundColor: "#F5F3F0"}}>
      {/* Filter bar — mirrored from unlocked state, all disabled */}
      <div
        className="px-5 py-3 border-b flex flex-wrap items-center gap-3 flex-shrink-0"
        style={{backgroundColor: "#FDFCF9", borderColor: "#E8E4DF"}}
      >
        <div className="relative flex-1 min-w-[200px] max-w-xs opacity-40 pointer-events-none">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{color: "#8490AA"}} />
          <input
            disabled
            className="w-full pl-9 pr-3 py-2 rounded-xl text-xs border outline-none"
            style={{backgroundColor: "#F7F5F2", borderColor: "#E8E4DF", color: "#282D4D"}}
            placeholder="Search candidates…"
          />
        </div>
        <div
          className="flex items-center gap-1 p-0.5 rounded-xl opacity-40 pointer-events-none"
          style={{backgroundColor: "#EDE9E3"}}
        >
          <button
            className="text-xs font-semibold px-3 py-1.5 rounded-lg"
            style={{backgroundColor: "white", color: "#282D4D"}}
          >
            All Talents
          </button>
          <Tooltip text="Upgrade Your Plan" position="top">
            <button
              className="text-xs font-semibold px-3 py-1.5 rounded-lg opacity-50"
              style={{backgroundColor: "transparent", color: "#8490AA"}}
            >
              Top Talents
            </button>
          </Tooltip>
          <Tooltip text="Upgrade Your Plan" position="top">
            <button
              className="text-xs font-semibold px-3 py-1.5 rounded-lg opacity-50"
              style={{backgroundColor: "transparent", color: "#8490AA"}}
            >
              Rising Talents
            </button>
          </Tooltip>
        </div>
        <div className="flex items-center gap-2 ml-auto opacity-40 pointer-events-none">
          <Ordering />
          <ManualFilters />
        </div>
      </div>

      {/* Locked overlay */}
      <div className="flex-1 relative overflow-hidden">
        {/* Blurred skeleton cards */}
        <div className="px-5 py-5 space-y-4 blur-sm pointer-events-none select-none">
          {Array.from({length: 5}).map((_, i) => (
            <div key={i} className="bg-white rounded-2xl overflow-hidden" style={{border: "1px solid #E8E4DF"}}>
              <div className="flex h-1.5">
                {Array.from({length: 4}).map((_, j) => (
                  <div key={j} className="flex-1 bg-brand-cream-dark" />
                ))}
              </div>
              <div className="px-5 py-4 flex items-start gap-4">
                <div className="w-14 h-14 rounded-full bg-brand-cream-dark flex-shrink-0" />
                <div className="flex-1 space-y-2 pt-1">
                  <div className="h-4 bg-brand-cream-dark rounded w-1/3" />
                  <div className="h-3 bg-brand-cream-dark rounded w-1/2" />
                  <div className="h-3 bg-brand-cream-dark rounded w-1/4" />
                </div>
                <div className="flex gap-2 flex-shrink-0">
                  <div className="h-6 w-20 bg-brand-cream-dark rounded-full" />
                  <div className="h-6 w-24 bg-brand-cream-dark rounded-full" />
                </div>
              </div>
              <div className="px-5 py-3 border-t border-brand-border flex gap-2" style={{backgroundColor: "#FAFAF9"}}>
                {Array.from({length: 4}).map((_, j) => (
                  <div key={j} className="w-9 h-9 rounded-full bg-brand-cream-dark" />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Centered upgrade CTA */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div
            className="bg-white rounded-2xl border border-brand-border p-8 flex flex-col items-center gap-4 text-center max-w-sm w-full"
            style={{boxShadow: "0 8px 32px rgba(40,45,77,0.1)"}}
          >
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center"
              style={{backgroundColor: "#EDE9E3"}}
            >
              <Lock className="w-6 h-6" style={{color: "#3D52AD"}} />
            </div>
            <div>
              <h3 className="text-lg font-bold text-brand-navy mb-1">Upgrade Your Plan</h3>
              <p className="text-sm text-brand-muted">
                You don't have access to Talent Finder. Contact us to unlock candidate search.
              </p>
            </div>
            <button
              onClick={onContactSales}
              className="px-6 py-2.5 rounded-xl text-sm font-semibold text-white transition-opacity hover:opacity-90"
              style={{backgroundColor: "#3D52AD"}}
            >
              Contact Sales
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentFinderLocker;
